import React from 'react'
import Divider from '@mui/material/Divider'
import { Container, Paper } from '@mui/material'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

function Footer() { 

    return (

        <Paper>
            <Divider
                sx={{
                    height: '1px',
                    position: 'fixed',
                    bottom: '8%',
                    width: '100%'
                }}
            >
                    
                <Typography variant="subtitle2" wrap gutterBottom
                    sx={{
                    marginTop: '6px',
                    fontFamily: 'sans-serif'
                    }}
                >  
                    © 2023 Native Maine Operations, Inc.
                </Typography>  

                <Typography variant="caption" wrap gutterBottom> 
                    <Link href="https://www.nativeme.com/contact" target="_BLANK" underline="hover"
                        sx={{
                        marginLeft: '4px',
                        marginRight: '4px',
                        fontFamily: 'sans-serif'
                        }}
                    >
                        Contact
                    </Link>|
                    <Link href="https://www.nativeme.com/about/terms-of-use" target="_BLANK" underline="hover"
                        sx={{
                        marginLeft: '4px',
                        marginRight: '4px',
                        fontFamily: 'sans-serif'
                        }}
                    >
                        Terms
                    </Link>
                </Typography> 

           
                
            </Divider>
        </Paper>

    )

}

export default Footer